import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { SwalConfs } from '../sweetalert-configurations';

@Injectable({providedIn: 'root'})
export class ToasterService {
    constructor() {}

    showSuccessToast(message: string, title: string = '') {
        Swal.fire(SwalConfs.getSuccessToast(title, message));
    }

    showErrorToast(title: string, message: string) {
        Swal.fire(SwalConfs.getErrorToast(title, message));
    }
}
